export enum ManageMediaKitFormFields {
  CurrentPortfolioId = 'currentPortfolioId',
  CurrentPropertyId = 'currentPropertyId',
  CurrentFoldersIds = 'currentFoldersIds',
  AddedMedia = 'addedMedia',
  RemovedMedia = 'removedMedia',
}

export const ManageMediaKitFormFieldsList = [
  ManageMediaKitFormFields.CurrentPortfolioId,
  ManageMediaKitFormFields.CurrentPropertyId,
  ManageMediaKitFormFields.CurrentFoldersIds,
  ManageMediaKitFormFields.AddedMedia,
  ManageMediaKitFormFields.RemovedMedia,
];
